<template>
  <aside class="summary">
    <section class="summary-top">
      <div class="summary-top__content">
        <h2 v-if="slots?.slot_type_billing === ModelBilling.prepago">Compra nuevos slots</h2>
        <h2 v-if="slots?.slot_type_billing === ModelBilling.postpago">Agrega nuevos slots</h2>
        <p>Adquiere nuevos usuarios</p>
      </div>
      <img src="../../assets/payment-cart.png" alt="cart icon" width="90" />
    </section>
    <section class="summary-middle">
      <p v-if="slots?.slot_type_billing === ModelBilling.prepago">
        Si se agregan slots durante el ciclo de facturación, se cobrará solo la parte proporcional.
        En el siguiente ciclo, se facturará por el total de usuarios.
      </p>
      <p v-if="slots?.slot_type_billing === ModelBilling.postpago">
        Los usuarios agregados durante el ciclo de facturación, serán cobrados al finalizar el mes.
      </p>
      <p v-if="slots?.slot_type_billing === ModelBilling.prepago">
        Número de slots que desea comprar:
      </p>
      <p v-if="slots?.slot_type_billing === ModelBilling.postpago">
        Número de slots que desea agregar:
      </p>
      <a-input-number class="input" :value="count" :min="1" @change="handleCountChange" />

      <!-- <h5>El precio por slot es tan solo de ${{ formattedPrice }}</h5> -->
      <div class="section_price__details--item">
        <span>Precio de slots</span>
        <span>${{ formattedPrice || 0 }}</span>
      </div>
      <div v-if="slots?.tax" class="section_price__details--item">
        <span>IGV (18%)</span>
        <span>${{ igvSlot }}</span>
      </div>

      <a-divider class="divider2"/>
      <h1 style="text-align: right;">Total: ${{ totalIncludeIgv}}</h1>
    </section>
    <section class="summary-btn">
      <div v-if="slots?.slot_type_billing === ModelBilling.postpago">
        <a-button type="primary" class="add" @click="handlePayment" :loading="loading">
          Agregar nuevos slots
        </a-button>
      </div>
      <div style="margin-bottom: 8px" v-if="slots?.slot_type_billing === ModelBilling.prepago">
        <PayUPaymentButton
          ref="rechargeRef"
          :amount="totalIncludeIgv"
          name="Comprar nuevos Slots"
          :type="ProductType.Slot"
          :count="count"
          :price="formattedPrice"
          title="Compra nuevos slots"
          action="compra"
          textButton="Realizar pago"
        />
      </div>
      <a-button @click="contactOpen = true"> Contactar con ventas </a-button>
      <!-- <input -->
      <!--   class="summary-btn__contact" -->
      <!--   name="submit" -->
      <!--   type="submit" -->
      <!--   value="Contactar con ventas" -->
      <!-- /> -->
      <!-- <a-button type="secondary" class="sales"> Contactar con ventas </a-button> -->
      <ContactSalesModal v-model:open="contactOpen" />
    </section>
    <a-divider class="divider" />
    <section class="summary-bottom">
      <h3>💡Información de Pago</h3>
      <p class="info">
        Para evitar cargos adicionales en tu próximo ciclo de facturación, asegúrate de eliminar los
        slots que ya no necesitas antes de tu fecha de facturación.
      </p>
    </section>
  </aside>
</template>

<script setup lang="ts">
import { ref, onMounted, toRefs, computed } from "vue";
import SlotManager from "@/app/settings/services/slots/SlotManager";
import PayUPaymentButton from "@/app/shared/components/buttons/PayUPaymentButton.vue";
// import SalesContact from "@/app/settings/components/modals/SalesContact.vue";
import ContactSalesModal from "../modals/ContactSalesModal.vue";
import { ISlots } from "@/@types/settings/slots";
import dayjs from "dayjs";
import { message } from "ant-design-vue";
import EventBus from "@/app/shared/utils/eventBus";
import { ProductType } from "@/@types/settings/billing";

const igvFactor = 1.18;
const success = () => {
  message.success("Se han agregado slots con éxito");
};
const error = () => {
  message.error("No puede pasar la cantidad máxima de slot asignados");
};

enum ModelBilling {
  prepago = "Prepago",
  postpago = "Postpago",
}

const props = defineProps<{ slots: ISlots }>();
const { slots } = toRefs(props);

const manager = new SlotManager();
const count = ref(1);
const price = ref(0);
const loading = ref(false);
const contactOpen = ref(false);

const purchaseSlots = async () => {
  const response = await manager.buySlots(handlePriceFormatt(), count.value);
  console.log(response, "response purcharse");
};

const handlePayment = async () => {
  loading.value = true;
  await new Promise((resolve) => setTimeout(resolve, 500));

  await purchaseSlots()
    .then(() => {
      loading.value = false;
      success();
      EventBus.emit("updateSlots");
      EventBus.emit("updateTable");
    })
    .catch(() => error());
};

const handlePriceFormatt = () => {
  const isPostpago = slots.value?.slot_type_billing === ModelBilling.postpago;
  const basePrice = isPostpago ? (slots.value?.slot_price ?? 0) : (slots.value?.slot_price_now ?? 0);
  return Number(basePrice.toFixed(2));
};

const formattedPrice = computed(() => handlePriceFormatt());

const totalPrice = computed(() => {
  const formattedPriceValue = handlePriceFormatt();
  const calculatedTotalPrice = formattedPriceValue * count.value;

  return Number(calculatedTotalPrice.toFixed(2));
});

const totalIncludeIgv = computed(() => {
  const totalIncludeIgvValue = totalPrice.value * (slots?.value?.tax ? igvFactor : 1);
  return Number(totalIncludeIgvValue.toFixed(2));
});

const igvSlot = computed(() => {
  const igvSlotValue = formattedPrice.value * slots?.value?.tax;
  return Number(igvSlotValue.toFixed(2));
})

const leftDaysToPay = computed(() =>
  Math.abs(dayjs().diff(slots.value?.date_payment_finish, "day"))
);

const handleCountChange = (newCount: number) => {
  count.value = newCount;
  console.log(count.value, "AMOUNT SLOT");
};

onMounted(() => {
  price.value = count.value * slots.value?.slot_price;
});

defineExpose({ handleCountChange });
</script>

<style lang="sass" scoped>
h1, h3, p
  margin: 0
h1
  font-size: 20px
h2
  line-height: 19px
h3
  color: $gray-9
  font-size: $font-normal
  font-weight: 600
h5
  color: $gray-7
  font-size: $font-small
  font-weight: 400
p
  color: $gray-13
  font-size: 14px
.divider
  background-color: $gray-5
  margin: 16px 0
.divider2
  background-color: $gray-5
  margin: 8px 0
.summary
  width: 100%
  height: 100%
  border: 1px solid $gray-5
  border-radius: 8px
  padding: 16px
  overflow: auto
  &-top
    display: flex
    justify-content: space-between
    margin-bottom: 4px
    &__content
      p:last-child
        font-size: $font-small
        color: $gray-7
  &-middle
    display: flex
    flex-direction: column
    gap: 5px
    padding: 5px 0 10px 0
    .input
      width: 100%
      margin-bottom: 8px
      p
        color: $gray-8
  &-bottom
    h3
      font-size: $font-medium
  &-btn
    display: flex
    flex-direction: column
    .add
      width: 100%
      cursor: poiner
    .ant-space
      .ant-space-item
        width: 100%
    input
      border-radius: 6px
      width: 100%
      padding: 5px 16px
      font-size: $font-normal
    &__payment
      color: $gray-2
      border: 1px solid var(--colorPrimaryBase, #1677FF)
      background: var(--colorPrimaryBase, #1677FF)
      box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.04)
    &__contact
      border: 1px solid $gray-5
      background: $white
      box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.04)
.section_price
  &__details
    text-align: right
    &--item
      display: flex
      align-items: center
      justify-content: end
      text-align: right
      gap: 24px
      color: #00000073
</style>
